import PropTypes from "prop-types";
import React, { Component } from "react";
import { Trans } from "@lingui/macro";
import {
  Button,
  Dialog,
  DialogTitle,
  MobileStepper,
  withStyles
} from "@material-ui/core";
const styles = () => ({
  dialog: {
    borderRadius: "15px",
    minWidth: "440px"
  }
});

class AlertConsigns extends Component {
  state = {
    open: true,
    activeConsign: 0
  };

  componentDidMount() {
    this.setState({ open: true });
  }

  handleCloseButton = () => {
    if (!this.props.noCancel && this.props.handleClose) {
      this.props.handleClose();
    }
  };

  getConsignElement = () => {
    if (this.props.consigns.length > 1) {
      return (
        <>
          <MobileStepper
            variant="dots"
            steps={this.props.consigns.length}
            position="static"
            activeStep={this.state.activeConsign}
            style={{ background: "white" }}
          />
          <div
            className="text-dialog"
            dangerouslySetInnerHTML={{
              __html: this.props.consigns[this.state.activeConsign]
            }}
          />
        </>
      );
    } else {
      return (
        <div
          className="text-dialog"
          dangerouslySetInnerHTML={{
            __html: this.props.consigns[0]
          }}
        />
      );
    }
  };

  render() {
    const isFirstConsign = this.state.activeConsign === 0;
    const isLastConsign =
      this.state.activeConsign === this.props.consigns.length - 1;
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="priority-dialog-title"
          open={this.state.open}
          onClose={this.handleCloseButton}
          style={{
            borderRadius: 10,
            padding: "0 20px", // Ajoute une marge de 20px à gauche et à droite
            maxWidth: "calc(100% - 40px)" // Limite la largeur du dialog à 100% moins 40px pour inclure la marge
          }}
        >
          <DialogTitle className="head-dialog" id="priority-dialog-title">
            <div className="title-dialog">
              <i className="material-icons">warning</i>
            </div>
          </DialogTitle>
          <div className="body-dialog dialog-s">
            {this.getConsignElement()}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                className="btn"
                color="primary"
                disabled={this.props.noCancel && this.state.activeConsign === 0}
                onClick={
                  isFirstConsign
                    ? this.handleCloseButton
                    : () =>
                        this.setState({
                          activeConsign: this.state.activeConsign - 1
                        })
                }
              >
                <Trans id={"W_STEP_BOUTON_RETOUR"} />
              </Button>
              <Button
                onClick={
                  isLastConsign
                    ? this.props.onClick
                    : () =>
                        this.setState({
                          activeConsign: this.state.activeConsign + 1
                        })
                }
                className="btn-filled"
                color="primary"
                variant="contained"
              >
                <Trans
                  id={isLastConsign ? "W_STEP_BOUTON_CONTINUER" : "W_SUIVANT"}
                />
              </Button>
            </div>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

AlertConsigns.propTypes = {
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  consigns: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleClose: PropTypes.func,
  noCancel: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(AlertConsigns);
